import { render, staticRenderFns } from "./cardSetting.vue?vue&type=template&id=14769df1&scoped=true&"
import script from "./cardSetting.vue?vue&type=script&lang=js&"
export * from "./cardSetting.vue?vue&type=script&lang=js&"
import style0 from "./cardSetting.vue?vue&type=style&index=0&id=14769df1&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14769df1",
  null
  
)

export default component.exports